import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'amos-h1',
  template: require('./h1.component.html'),
  styles: [require('./h1.component.css')]
})
export class H1Component {
  constructor() { }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/micro-components/h1-component/h1.component.ts